import { render, staticRenderFns } from "./AddCampaign.vue?vue&type=template&id=3bc98a87&scoped=true&"
import script from "./AddCampaign.vue?vue&type=script&lang=js&"
export * from "./AddCampaign.vue?vue&type=script&lang=js&"
import style0 from "./AddCampaign.vue?vue&type=style&index=0&id=3bc98a87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc98a87",
  null
  
)

export default component.exports